<template>
    <div v-if="show" :class="['basket-nav-card-wrap', {'open': openCard, 'disabled': cardLoaderStatus }]">
        <div v-show="windowWidth <= 1400"
             @click="toggleCard()"
             class="basket-icon">
            <icon name="basket" width="26px" height="26px" fill="var(--white-color)"/>
        </div>

        <div ref="card" class="basket-nav-card relative">
            <div v-show="windowWidth > 1400" class="card-header align-center">
                <icon name="basket" width="20px" height="20px" />
                <span class="ml-8">{{ localizeList.basketUpper }}</span>
            </div>

            <div class="price-row">
                <div>
                    <p class="main-info">{{ tourMainInfo }}</p>
                </div>
                <p v-if="tourCardData.price === 0" class="error-price">
                    Бронирование по нулевой цене невозможно!
                </p>
            </div>

            <div v-for="(item, key) in tourCardData.serviceTourists"
                 v-show="tourCardData.serviceTourists.length && !hoodedServices.includes(item.ServiceType)"
                 :key="key"
                 @click="scrollToBlock(item.type ? item.type : 'additionalServices')"
                 class="card-row">
                <template v-if="item.type">
                    <div class="icon-wrap">
                        <icon :name="item.typeIcon" width="21px" height="20px" fill="var(--lighten-5-color)" />

                        <p class="standard-text-small nowrap">{{item.Day}} {{localizeList.dayShort}}</p>
                        <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                    </div>
                    <div class="row-text">
                        <p class="word-break">
                            {{ item.Name }}
                            {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                        </p>
                        <div class="align-center mt-2">
                            <div class="popover-link" v-for="(item3, key3) in item.COAndSpecialInfo" :key="`${key3}_2`">   
                                <div v-if="hasCoImage(item)" 
                                    v-show="item3.title"
                                    @mouseleave="hidePopover()"
                                    @mouseenter="showPopover(item3.title, $event, true)"> 
                                    <img v-if="item3.type === 1"
                                            width="20px" height="20px"
                                            :src="item3.src"
                                            class="hotel-type-icon"/>
                                    <img v-else
                                            width="26px" height="26px"
                                            style="margin-top: -4px"
                                            :src="item3.src"
                                            class="hotel-type-icon"/>
                                </div>                        
                                <div v-else-if="item3.title.length > 1"
                                    v-show="item3.title"
                                    @mouseleave="hidePopover()"
                                    @mouseenter="showPopover(item3.title, $event, true)">
                                    <img v-if="item3.type === 1"
                                            width="20px" height="20px"
                                            :src="item3.src"
                                            class="hotel-type-icon"/>
                                    <img v-else
                                            width="26px" height="26px"
                                            style="margin-top: -4px"
                                            :src="item3.src"
                                            class="hotel-type-icon"/>
                                </div>
                            </div>

                        </div>
                        <!-- <div class="align-center">
                            <span>{{ localizeList.editUpper }}</span> -->

<!--                            <div v-if="item.ServiceType === 3 && outHotelInfoShow(item)" class="popover-link ml-4"-->
<!--                                 @mouseleave="hidePopover()"-->
<!--                                 @mouseenter="showPopover(outHotelInfo(item), $event)">-->
<!--                                <icon name="info"-->
<!--                                      @click.native="alertShow(item.key, outHotelCalculateData[item.key].find(x => x.AdditionalInfo) ? 5000 : 0)"-->
<!--                                      width="16px" height="16px" fill="var(--primary-color)"/>-->
<!--                            </div>-->
                        <!-- </div> -->
                    </div>
<!--                    <div class="popover-link"-->
<!--                         @mouseleave="hidePopover()"-->
<!--                         @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                        <icon :name="getQuotaName(item.quota, item)"-->
<!--                              width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                    </div>-->
                </template>
                <template v-else>
                    <div class="icon-wrap">
                        <svg width="14px" height="20px" fill="var(--lighten-5-color)">
                            <use xlink:href="../../../assets/images/sprite.svg#map-icon"></use>
                        </svg>

                        <p class="standard-text-small mt-2">{{item.Day}} {{localizeList.dayShort}}</p>
                        <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                    </div>
                    <div class="row-text">
                        <p>
                            {{ item.Name }}
                            {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                        </p>
                        <!-- <span>{{ localizeList.editUpper }}</span> --> 
                    </div>
<!--                    <div class="popover-link"-->
<!--                         @mouseleave="hidePopover()"-->
<!--                         @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                        <icon :name="getQuotaName(item.quota, item)"-->
<!--                              width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                    </div>-->

                </template>
            </div>

            <!-- Обязательные услуги-->
            <template v-if="tourCardData.requiredServices.length">
                <h4 class="required-title">{{localizeList.requiredServicesUpper}}</h4>
                <div v-for="(item, key) in tourCardData.requiredServices"
                     v-show="!hoodedServices.includes(item.ServiceType)"
                     :key="`required-${key}`"
                     @click="scrollToBlock(item.type ? item.type : 'additionalServices')"
                     class="card-row">
                    <template v-if="item.type">
                        <div class="icon-wrap">
                            <icon :name="item.typeIcon" width="21px" height="20px" fill="var(--lighten-5-color)" />

                            <p class="standard-text-small nowrap">
                                {{item.Day}}
                                {{localizeList.dayShort}}
                            </p>
                            <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                        </div>
                        <div class="row-text">
                            <p>
                                {{ item.Name }}
                                {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                            </p>
                            <p>{{`(${correctPrice(item.Brutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</p>
                            <!-- <span>{{ localizeList.editUpper }}</span> -->
                        </div>
<!--                        <div class="popover-link"-->
<!--                             @mouseleave="hidePopover()"-->
<!--                             @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                            <icon :name="getQuotaName(item.quota, item)"-->
<!--                                  width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                        </div>-->

                    </template>
                    <template v-else>
                        <div class="icon-wrap">
                            <svg width="14px" height="20px" fill="var(--lighten-5-color)">
                                <use xlink:href="../../../assets/images/sprite.svg#map-icon"></use>
                            </svg>

                            <p class="standard-text-small mt-2">{{item.Day}} {{localizeList.dayShort}}</p>
                            <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                        </div>
                        <div class="row-text">
                            <p>
                                {{ item.Name }}
                                {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                            </p>
                            <p>{{`(${correctPrice(item.Brutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</p>
                            <!-- <span>{{ localizeList.editUpper }}</span> -->
                        </div>
<!--                        <div class="popover-link"-->
<!--                             @mouseleave="hidePopover()"-->
<!--                             @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                            <icon :name="getQuotaName(item.quota, item)"-->
<!--                                  width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                        </div>-->

                    </template>
                </div>
            </template>

            <!-- Дополнительные услуги-->
            <template v-if="tourCardData.additionalServices.length">
                <h4 class="additional-title">{{localizeList.additionalServicesUpper}}</h4>
                <div v-for="(item, key) in tourCardData.additionalServices"
                     :key="`additional-${key}`"
                     @click="scrollToBlock(item.type ? item.type : 'additionalServices')"
                     class="card-row">
                    <template v-if="item.type">
                        <div class="icon-wrap">
                            <icon :name="item.typeIcon"
                                  width="21px" height="20px" fill="var(--lighten-5-color)"/>

                            <p class="standard-text-small nowrap">{{item.Day}}
                                {{localizeList.dayShort}}
                            </p>
                            <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                        </div>
                        <div class="row-text">
                            <p>
                                {{ item.Name }}
                                {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                            </p>
                            <p>{{`(${correctPrice(item.Brutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</p>
                            <!-- <span>{{ localizeList.editUpper }}</span> -->
                        </div>
<!--                        <div class="popover-link"-->
<!--                             @mouseleave="hidePopover()"-->
<!--                             @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                            <icon :name="getQuotaName(item.quota, item)"-->
<!--                                  width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                        </div>-->

                    </template>
                    <template v-else>
                        <div class="icon-wrap">
                            <svg width="14px" height="20px" fill="var(--lighten-5-color)">
                                <use xlink:href="../../../assets/images/sprite.svg#map-icon"></use>
                            </svg>

                            <p class="standard-text-small nowrap">
                                {{item.Day}}
                                {{localizeList.dayShort}}
                            </p>
                            <p class="standard-text-small nowrap"> {{ getServiceDate(item.Day) }}</p>
                        </div>
                        <div class="row-text">
                            <p>
                                {{ item.Name }}
                                {{item.ServiceType !== 3 ? "x"+ item.TouristCount : ""}}
                            </p>
                            <p>{{`(${correctPrice(item.Brutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</p>
                            <!-- <span>{{ localizeList.editUpper }}</span> -->
                        </div>
<!--                        <div class="popover-link"-->
<!--                             @mouseleave="hidePopover()"-->
<!--                             @mouseenter="showPopover(getQuotaText(item.quota, item), $event)">-->
<!--                            <icon :name="getQuotaName(item.quota, item)"-->
<!--                                  width="16px" height="16px" fill="var(&#45;&#45;white-color)"/>-->
<!--                        </div>-->

                    </template>
                </div>
            </template>

            <div v-if="trevelerForm.length"
                 @click="scrollToBlock('trevelerData')"
                 class="card-row">
                <div class="icon-wrap">
                    <icon name="profile" width="20px" height="20px" fill="var(--lighten-5-color)"/>
                </div>
                <div class="row-text">
                    <p>{{ localizeList.tourists }}</p>
                    <span>{{ localizeList.enterData }}</span>
                </div>
                <icon v-if="touristValidStatus" name="aviailable" width="16px" height="16px" fill="var(--white-color)"/>

            </div>

            <promocodesBlock v-if="isAuthenticated && getWindowSettings.usePromoDiscounts"
                             :tour="tour"
                             :userInfo="userInfo"
                             :trevelerInfo="trevelerInfo"
                             @applyPromoOrDiscount="$emit('applyPromoOrDiscount', $event)"
                             @discountTypeData="$event => discountTypeData = $event"/>

            <!-- Branch and managers -->
            <div v-show="isAuthenticated && branches.list.length" class="managers-branches-wrap">
                <div v-show="branches.list.length > 2" class="branches mb-8">
                    <p class="dark-small-text mb-4">{{ localizeList.reservationBranchUpper }}</p>
                    <base-select :items="branches.list"
                                 @change="changeBranch($event)"
                                 v-model="branches.selected"></base-select>
                </div>
                <div v-show="managers.list.length > 2" class="branches">
                    <p class="dark-small-text mb-4">{{ localizeList.seniorManagerUpper }}</p>
                    <base-select :items="managers.list"
                                 v-model="managers.selected"></base-select>
                </div>
            </div>

            <div v-show="isAuthenticated && userInfo.UserType === 1 && tourCardData.initialized" class="user-info">
                <div v-if="getWindowSettings.usePromoDiscounts" class="user-info-row">
                  <template v-if="discountTypeData.value === 0">
                      <span>{{ localizeList.promocode }}:</span>

                      <div class="align-center nowrap">
                          <p class="font-bold mr-2">
                              {{`(${ promocodeData.promoIsDiscountIsPercent ? promocodeData.promoDiscount : promocodeData.promoTotalDiscount } ${promocodeData.promoIsDiscountIsPercent ? '%' : getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}
                          </p>
                          <p class="font-bold">
                              {{`(${ correctPrice(promocodeData.promoNationalDiscount)} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                          </p>
                      </div>
                  </template>
                  <template v-else>
                    <span class="discount-label">{{ discountTypeData.label }}:</span>
                    <div class="align-center nowrap">
                          <p class="font-bold mr-2">
                              {{`(${ discountCardData.promoIsDiscountIsPercent ? discountCardData.promoDiscount : discountCardData.promoTotalDiscount } ${discountCardData.promoIsDiscountIsPercent ? '%' : getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}
                          </p>
                          <p class="font-bold">
                              {{`(${ correctPrice(discountCardData.promoNationalDiscount)} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                          </p>
                      </div>
                  </template>
                </div>
 
                <div class="user-info-row">
                    <span>{{localizeList.yourDiscount}}:</span>
                    <div class="align-center">
                        <p class="font-bold mr-2">
                            {{`(${ tourCardData.discount } ${tourCardData.isDiscountIsPercent ? '%' : getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}
                        </p>
                        <p class="font-bold">
                            {{`(${ correctPrice(tourCardData.nationalTotalDiscount)} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="price-status-block">
                <div class="row">
                    <p>{{ `${localizeList.tourCost}:` }}</p>
                    <p v-show="tourCardData.currency" class="font-bold nowrap">
                        {{ `${correctPrice(tourCardData.calculatedServicesPrice)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}` }}
                        <span v-show="showNationalPrice">({{ `${correctPrice(tourCardData.natinoalCalculatedServicesPrice)}
                            ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)}` }})</span>
                    </p>
                </div>
                <div v-show="showAdditionalPrices" class="additional">
                    <p class="title">{{localizeList.additionally}}</p>
                    <div v-show="requiredServicesBrutto" class="row">
                        <p>{{ `${localizeList.requiredServicesCost}:` }}</p>
                        <p v-show="tourCardData.currency" class="font-bold nowrap">
                            {{ `${correctPrice(requiredServicesBrutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}`}}
                            <span v-show="showNationalPrice">{{`(${correctPrice(requiredServicesNationalBrutto)} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})` }}</span>
                        </p>
                    </div>
                    <div v-show="additionalServicesBrutto" class="row">
                        <p>{{ `${localizeList.additionalServicesCost}:` }}</p>
                        <p v-show="tourCardData.currency" class="font-bold nowrap">
                            {{ `${correctPrice(additionalServicesBrutto)} ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}`}}
                            <span v-show="showNationalPrice">{{`(${correctPrice(additionalServicesNationalBrutto)} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})` }}</span>
                        </p>
                    </div>
                    <div v-show="tourCardData.changedPrice" class="row">
                        <p>
                            {{ localizeList.priceChangedOn }}:
                        </p>
                        <p v-show="tourCardData.currency" class="font-bold nowrap">
                            {{ `${ correctPrice(Math.abs(tourCardData.changedPrice)) } ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}` }}
                            <span v-show="showNationalPrice">({{ correctPrice(tourCardData.nationalChangedPrice) }} {{ getCurrencyDisplayBySettings(tourCardData.nationalCurrency)}})</span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <p class="total-pay">{{localizeList.totalToPay}}:</p>
                    <p v-show="tourCardData.currency" class="total-pay-price nowrap">
                        {{ isAuthenticated && userInfo.UserType === 1 ? correctPrice(tourCardData.price) : correctPrice(tourCardData.totalPrice) }} {{ getCurrencyDisplayBySettings(tourCardData.tourCurrency) }}
<!--                        <span v-show="showNationalPrice">({{ correctPrice(tourCardData.nationalPrice) }} {{ getCurrencyDisplayBySettings(tourCardData.nationalCurrency)}})</span>-->
                    </p>
                </div>

                <div class="row" v-show="isForeignCurrency && tourCardData.initialized">
                    <div class="flex">
                        <span>Информация </span>

                        <div class="popover-link"
                             @mouseleave="hidePopover()"
                             @mouseenter="showPopover(`${localizeList.currencyRateInfo}
                             1 ${tourCardData.currency} = ${currencyRateInRb} ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)}`, $event)">
                             
                             <icon class="ml-3" name="info" width="16" height="16" fill="var(--lighten-5-color)" />
                       </div>
                    </div>

                    <span >
                    = {{ correctPrice(tourCardData.nationalTotalPrice) }} {{ getCurrencyDisplayBySettings(tourCardData.nationalCurrency) }}
                    </span>
                </div>
            </div>

            <div v-show="isAuthenticated && userInfo.UserType === 0 && tourCardData.initialized" class="comission-info">
                <div @click="toggleComission()" class="align-center justify-end pointer">
                    <h4 class="standard-500-text mb-2">{{ localizeList.agencies }}</h4>
                    <svg :class="['agencies-drop-icon ml-4', {'active': showComission}]" width="10px"
                         height="10px" fill="#a1a1a1">
                        <use xlink:href="../../../assets/images/sprite.svg#angle"></use>
                    </svg>
                </div>
                <div v-show="showComission">
                  <div v-if="getWindowSettings.usePromoDiscounts" class="comission-row">
                      <span>{{`${localizeList.promocode}: (${promocodeData.promoIsDiscountIsPercent ? promocodeData.promoDiscount : promocodeData.promoTotalDiscount} ${promocodeData.promoIsDiscountIsPercent ? '%' : getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</span>
                      <div class="align-center nowrap">
                          <p class="font-bold mr-2">
                              {{`${ correctPrice(promocodeData.promoTotalDiscount) } ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}`}}
                          </p>
                          <p v-show="showNationalPrice" class="font-bold">
                              {{`(${ correctPrice(promocodeData.promoNationalDiscount)
                              } ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                          </p>
                      </div>
                    </div>
                    <div class="comission-row">
                        <span>{{`${localizeList.commission}: (${tourCardData.discount} ${tourCardData.isDiscountIsPercent ? '%' : getCurrencyDisplayBySettings(tourCardData.tourCurrency)})`}}</span>
                        <div class="align-center">
                            <p class="font-bold mr-2">
                                {{`${ correctPrice(tourCardData.totalDiscount) } ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}`}}
                            </p>
                            <p v-show="showNationalPrice" class="font-bold">
                                {{`(${ correctPrice(tourCardData.nationalTotalDiscount)
                                } ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                            </p>
                        </div>
                    </div>
                    <div class="comission-row">
                        <span>{{ localizeList.summaryUpper }}:</span>
                        <div class="align-center">
                            <p class="font-bold mr-2">
                                {{`${ correctPrice(tourCardData.price) } ${getCurrencyDisplayBySettings(tourCardData.tourCurrency)}`}}
                            </p>
                            <p v-show="showNationalPrice" class="font-bold">
                                {{`(${ correctPrice(tourCardData.nationalPrice)
                                } ${getCurrencyDisplayBySettings(tourCardData.nationalCurrency)})`}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

          <div v-if="brutto.length"
               class="brutto-wrap pl-8 pr-8">
            <div class="warning-block">
              <div v-for="(item, key) in brutto"
                   :key="key"
                   :class="['align-center', {'mt-4': key > 0}]">
                <icon class="mr-4"
                      name="info" width="18" height="18" fill="var(--primary-color)" />
                <span v-html="item" class="standard-text-small"></span>
              </div>
            </div>
          </div>

            <div class="links-wrap">
                <div style="margin: 10px 0px 10px 0px;">
                      <checkbox v-if="iAgreeToReceiveVisible"  v-model="iAgreeToReceive"><h6 style="font-weight:normal; font-size: small;">{{ localizeList.receiveAgreedUpper }}</h6></checkbox>
                </div>
                <h6 class="grey-text-small mb-3 text-500">{{localizeList.clickBookAccept}}:</h6>

                <a v-if="termsTariffs && termsTariffs.length && hasAviaFlight"
                   :href="termsTariffs"
                   target="_blank">
                    {{localizeList.termsTariffs}}
                </a>

                <a v-if="submittingAgreePrivacyPolicy && submittingAgreePrivacyPolicy.length"
                   :href="submittingAgreePrivacyPolicy"
                   target="_blank">
                    {{localizeList.submittingAgreePrivacyPolicy}}
                </a>

                <a v-if="offerLink && offerLink.length"
                   :href="offerLink"
                   target="_blank">
                    {{localizeList.offerAgreement}}
                </a>

                <p v-if="tourBookingHTML && tourBookingHTML.length || hasTourImage"
                   @click="rightModalBooking()"
                   class="booking-info">{{ localizeList.tourBookingConditions }}</p>

                <h6 class="grey-text-small mt-3 text-500">{{localizeList.giveConsentSpecifiedPersonsForProcessingPersonalData}}</h6>
            </div>

            <div v-show="isAuthenticated && userInfo.UserType === 1 && showAgreeTermsBookingCheckbox" id="clientAgree" class="justify-end pr-10">
                <checkbox small
                          v-model="clientAgree">
                </checkbox>
                <a :href="аgreementAccord" target="_blank" class="blue-text-small">
                    {{localizeList.agreeWithOrderConditions}}
                </a>
            </div>

            <div class="buy-btn-wrap">
                <base-button @click="buyTour()"
                             class="buy-btn-item"
                             background="var(--orange-color)"
                             :disabled="cardLoaderStatus"
                             size="18px">{{ localizeList.registerBooking }}
                </base-button>

                <div v-if="getWindowSettings.showQuiQuoService && getQuiQuoJSON()" class="qq-btn-place qui-quo-item" :data-value="getQuiQuoJSON()">
                </div>
            </div>

            <quickBookingQuiQuo v-if="getWindowSettings.showQuiQuoService"
                                :tour="tour"
                                :selectedFlight="selectedFlight"
                                :tourCardData="tourCardData"
                                :residence="residence"
                                :trevelerInfo="trevelerInfo"
                                :insuranceItems="insuranceItems"
                                :transfer="transfer"
                                :additionalServices="additionalServices"
                                :flightSurcharge="flightSurcharge"
                                :busTransfer="busTransfer"
                                :railwayTransfer="railwayTransfer"
                                :excursion="excursion"
                                :visaItems="visaItems"
                                :hotelServices="hotelServices" />

            <div v-if="cardLoaderStatus" ref="cardLoader" class="card-loader-wrap">
                <base-loader size="50" weight="3"></base-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import {bus} from "../../../main";
    import moment from "moment";
    import promocodesBlock from "./promocodes/promocodesBlock";
    import quickBookingQuiQuo from "./quiQuo/quickBookingQuiQuo.vue";

    export default {
        name: "buyCard",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            openCard: {
                type: Boolean,
                default: false
            },
            isAuthenticated: {
                type: Boolean,
                default: false
            },
            showComission: {
                type: Boolean,
                default: false
            },
            cardLoaderStatus: {
                type: Boolean,
                default: false
            },
            touristValidStatus: {
                type: Boolean,
                default: false
            },
            tourCardData: {
                type: Object,
                default: () => {}
            },
            tour: {
                type: Object,
                default: () => {}
            },
            flight: {
                type: Array,
                default: () => [],
            },
            residence: {
                type: Array,
                default: () => []
            },
            branches: {
                type: Object,
                default: () => {}
            },
            managers: {
                type: Object,
                default: () => {}
            },
            userInfo: {
                type: Object,
                default: () => {}
            },
            hoodedServices: {
                type: Array,
                default: () => []
            },
            trevelerForm: {
                type: Array,
                default: () => []
            },
            trevelerInfo: {
                type: Array,
                default: () => []
            },
            outHotelCalculateData: {
                type: Array,
                default: () => []
            },
            adultCount: {
                type: [Number, Object],
                default: null
            },
            childCount: {
                type: [Number, Object],
                default: null
            },
            showNationalPrice: {
                type: Boolean,
                default: false
            },
            hasTourImage: {
                type: Boolean,
                default: false
            },
            tourBookingHTML: {
                type: String,
                default: ""
            },
            windowWidth: {
                type: Number,
                default: 0
            },
            offerLink: {
                type: String,
                default: ''
            },
            termsTariffs: {
                type: String,
                default: ''
            },
            submittingAgreePrivacyPolicy: {
                type: String,
                default: ''
            },
            iAgreeToReceiveVisible:{
                type: Boolean,
                default: false
            },
            tourHeadline: {
                type: Object,
                default: () => {}
            },
            insuranceItems: {
                type: Array,
                default: () => []
            },
            transfer: {
                type: Array,
                default: () => []
            },
            additionalServices: {
                type: Array,
                default: () => []
            },
            flightSurcharge: {
                type: Array,
                default: () => []
            },
            busTransfer: {
                type: Array,
                default: () => []
            },
            railwayTransfer: {
                type: Array,
                default: () => []
            },
            excursion: {
                type: Array,
                default: () => []
            },
            visaItems: {
                type: Array,
                default: () => []
            },
            hotelServices: {
                type: Array,
                default: () => []
            },
            selectedFlight: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                clientAgree: false,
                showAgreeTermsBookingCheckbox: window.settings.showAgreeTermsBookingCheckbox || window.settings.showAgreeTermsBookingCheckbox === undefined,
                defaultTop: null,
                discountTypeData: {
                  value: 0,
                  label: "",
                },
                promocodeData: {
                  promoDiscount: 0,
                  promoTotalDiscount: 0,
                  promoNationalDiscount: 0,
                  promoIsDiscountIsPercent: true,
                },
                discountCardData: {
                  promoDiscount: 0,
                  promoTotalDiscount: 0,
                  promoNationalDiscount: 0,
                  promoIsDiscountIsPercent: true,
                },
                coInfoList: []
                // iAgreeToReceive:true
            }
        },
        computed: {
            getWindowSettings(){
                return window.settings
            },
            iAgreeToReceive: {
                get(){
                    return this.$store.getters['basket/getAgreeToReceive']
                },
                set(value){
                    this.$store.commit('basket/M_SET_AGREE_TO_RECEIVE', value)
                }
            },
            isForeignCurrency(){
                return this.tourCardData.tourCurrency.IsoCode !== 'RUB'
            },
            currencyRateInRb(){
                const currencyId = this.tourCardData.tourCurrency.Id
                const currencyObj = this.$store.getters['getCurrencyRates'].find(item => item.CurrencyId === currencyId)
                return currencyObj?.Rate.toFixed(2)
            },
            аgreementAccord() {
                return `${location.origin}${location.pathname}/AgreementAccord.html`;
            },
            hasAviaFlight() {
                return this.tourCardData.serviceTourists
                        .map(x => x.ServiceType)
                        .includes(1)
            },
            tourMainInfo() {
                const name = this.tourCardData.tourName;
                const beginDate = this.getCorrectDate(this.tourCardData.beginDate);
                const endDate = this.getCorrectDate(this.tourCardData.endDate);
                const from = this.localizeList.from;
                const to = this.localizeList.to;

                return `${name} / ${from} ${beginDate} ${to} ${endDate}`
            },
            showAdditionalPrices() {
                return this.requiredServicesBrutto || this.additionalServicesBrutto || this.tourCardData.changedPrice
            },
            requiredServicesBrutto() {
                let res = 0;

                if (this.tourCardData.requiredServices.length) {
                    res = this.tourCardData.requiredServices
                        .map(x => x.Brutto)
                        .reduce((acum, x) => parseInt(acum) + parseInt(x))
                }

                return res
            },
            requiredServicesNationalBrutto() {
                let res = 0;

                if (this.tourCardData.requiredServices.length) {
                    res = this.tourCardData.requiredServices
                        .map(x => x.NationalBrutto)
                        .reduce((acum, x) => parseInt(acum) + parseInt(x));

                    if (res === null) res = 0;
                }

                return res.toFixed(2)
            },
            additionalServicesNationalBrutto() {
                let res = 0;

                if (this.tourCardData.additionalServices.length) {
                    res = this.tourCardData.additionalServices
                        .map(x => x.NationalBrutto)
                        .reduce((acum, x) => parseInt(acum) + parseInt(x))
                }

                return res ? res.toFixed(2) : 0;
            },
            additionalServicesBrutto() {
                let res = 0;

                if (this.tourCardData.additionalServices.length) {
                    res = this.tourCardData.additionalServices
                        .map(x => x.Brutto)
                        .reduce((acum, x) => parseInt(acum) + parseInt(x))
                }

                return res
            },
          brutto() {
            if (this.outHotelCalculateData.length === 1 && !this.outHotelCalculateData[0].length) return [];

            return this.outHotelCalculateData.map((x, i) => this.outHotelInfo({key: i})).filter(x => x);
          }
        },
        created() {
            bus.$on('basketClientAgree', val => {
                this.clientAgree = val
            });

            window.addEventListener('scroll', this.scroll)
        },
        mounted() {
            if (!this.showAgreeTermsBookingCheckbox) {
                this.clientAgree = true
            }
            if (this.tourCardData.serviceTourists.length) {
                this.coInfoList = [];
                this.getCOImages(this.tourCardData);
            }
            this.scroll();
        },
        methods: {
            getServiceDate(day) {
              const beginDate = this.tourCardData.beginDate;
              const serviceDate = moment(beginDate).add(day - 1, 'days').format("DD.MM.YYYY");

              return serviceDate;
            },
            getQuiQuoJSON(){
                const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
                const { adult, childs, childAges } = this.getAdultAndChildsFromHref()
                const serviceTourCardData = this.tourCardData.serviceTourists.find(el => el.type === 'residence')
                const [residence] = this.residence
                if(!serviceTourCardData || !this.tour || !residence) return;
                
                const serviceTour = this.tour.Services.find(el => el.SvKey === 3)
                const foodHeader = residence.selectedFood || residence.foodHeaderAll[0]

                const hotelUrl = serviceTour.Http;
                const tourUrl = this.tour.TourUrl;
                const tourName = this.tour.Name;

                const name = getTourDataQuiQuo ? tourName : serviceTour.Hotel.Value;
                const href = getTourDataQuiQuo ? tourUrl : hotelUrl

                const startDate = this.tour.StartDate.split('T')[0];
                const [year, month, day] = startDate.split('-') 
                const beginDate = `${day}.${month}.${year}`

                const imageUrl = this.residence[0]?.hotelImages[0];
                const cityAndResortString = residence.hotelResort ? `${residence.hotelCity}, ${residence.hotelResort}` : residence.hotelCity

                const QuiQuoObject = {
                    checkinDt: beginDate,
                    nights: String(this.tour.DurationInNight),
                    hotelName: name,
                    roomType: serviceTourCardData.Name,  
                    boardType: foodHeader,
                    price: this.tourCardData.totalPrice,
                    currency: this.tourCardData.tourCurrency?.IsoCode || this.getCurrencyFromHref(),
                    city_from: this.tourHeadline.from,
                    occupancy: {
                    adultsCount: parseInt(adult),
                    childrenCount: childs || 0,
                    childAges: childAges || 0,
                    },
                    region: cityAndResortString,
                    country: residence.hotelCountry,
                    thumbnail: imageUrl || "",
                    href
                }

                return JSON.stringify(QuiQuoObject)
            },
            getCurrencyFromHref(){
                let currency;
                location.href.split('&').forEach(x => {
                    if (x.includes('currency')) {
                    currency = x.split('=')[1]
                    }
                });
                return currency
            },
            getAdultAndChildsFromHref(){
                let adult = null;
                let childs = null;
                let childAges = null;

                location.href.split('&').forEach(x => {
                    if (x.includes('adultCount')) {
                    adult = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childAges = x.split('=')[1]
                    }
                    if (x.includes('childAges')) {
                    childs = x.split('=')[1].split(',').length
                    }
                });

                return {
                    adult,
                    childs,
                    childAges
                }
            },
            alertShow(key, time) {
                this.$emit("alertShow", [key, time])
            },
            outHotelInfo(item) {
                let text = "";
                this.outHotelCalculateData[item.key].forEach(x => {
                    if (x.Amount > 0) {
                        text += this.localizeList.cancellationPolicyInfo
                            .replace("{0}", this.correctPrice(x.Amount))
                            .replace("{1}", x.Currency)
                            .replace("{2}", this.correctDate(x.Date));
                    } else if (x.NmbrOfNights > 0) {
                        text += this.localizeList.cancellationPolicyWithNights
                            .replace("{0}", this.correctPrice(x.NmbrOfNights))
                            .replace("{1}", this.correctDate(x.Date));
                    } else {
                        text += this.localizeList.cancellationPolicyWithoutPenaltyInfo
                            .replace("{0}", this.correctDate(x.Date));
                    }
                });
                return text
            },
            // outHotelInfoShow(item) {
            //     return this.outHotelCalculateData[item.key].length;
            // },
            correctDate(date) {
                let correctDate = date.split("T")[0];
                return correctDate.split("-").reverse().join(".");
            },
            scroll() {
                const basketNavCardWrap = document.querySelector('.basket-nav-card-wrap');
                if (!basketNavCardWrap) {
                    setTimeout(() => (this.scroll()),1000/60);
                    return;
                }

                basketNavCardWrap.style.opacity = "1";
                if (this.windowWidth > 1400) return;

                const tourNavbar = document.querySelector('.tour-navbar');
                const basketNavCard = document.querySelector('.basket-nav-card');
                const scrollTop = window.pageYOffset;
                const scrollBottom = scrollTop + window.innerHeight;
                const footer = document.querySelector('.footer');
                const footerVisibleSpace = scrollBottom - footer.offsetTop;

                if (this.defaultTop === null)
                    this.defaultTop = parseInt(getComputedStyle(basketNavCardWrap).top);

                const top = tourNavbar.offsetTop - scrollTop + this.defaultTop;
                basketNavCardWrap.style.transition = "0s";
                basketNavCardWrap.style.top = top > this.defaultTop ? top + "px" : this.defaultTop + "px";

                basketNavCard.style.bottom = footerVisibleSpace > 0 ? `${footerVisibleSpace}px` : "unset";
            },
            getCorrectDate(str) {
                let res = str.split('T');
                res = res[0].split('-').reverse().join('.');

                return res
            },
            buyTour() {
                this.$emit('buyTour', {iAgreeToReceive: this.iAgreeToReceive})
            },
            rightModalBooking() {
                this.$emit('rightModalBooking')
            },
            changeBranch(val) {
                this.$emit('changeBranch', val)
            },
            scrollToBlock(val) {
                this.$emit('scrollToBlock', val)
            },
            toggleCard() {
                const basketNavCardWrap = document.querySelector('.basket-nav-card-wrap');
                basketNavCardWrap.style.transition = "0.2s all";

                this.$emit('toggleCard')
            },
            toggleComission() {
                this.$emit('toggleComission')
            },
            getQuotaText(quota, item) {
              // let isShowFewCountPlaces=this.$store.getters.getSettings.IsShowFewCountPlaces;
              let hotel=this.$parent.residence.find(x=>x.allData.COAndSpecialsInfo.AppliedCostOffersKeys[0]==item.AppliedCOInfo[0].IdCostOffer);

                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quota || !quotaServices.includes(item.ServiceType)) {
                    return null
                }

                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = this.localizeList.quotaHasNoPlaces
                } else if (quota.PlacesStatus === 4) {
                    res = this.localizeList.onRequest
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {

                   if (item.ServiceType==3 )
                   {
                     if (hotel.allData.HotelDetails[0].QuotaStatus.PlacesStatus===1 && hotel.allData.HotelDetails[0].QuotaStatus.FreePlaces > 0)
                     {
                       const placesLeft = hotel.allData.HotelDetails[0].QuotaStatus.FreePlaces === 1 ? 'placesLeft1' : (hotel.allData.HotelDetails[0].QuotaStatus.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                       res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                     }
                     else
                     {
                       res = this.localizeList.available
                     }
                   }
                   else
                   {
                    const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                    res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
                   }
                } else {
                    res = this.localizeList.available
                }
                return res
            },
            getQuotaName(quota, item) {
              let hotel=this.$parent.residence.find(x=>x.allData.COAndSpecialsInfo.AppliedCostOffersKeys[0]==item.AppliedCOInfo[0].IdCostOffer);
                const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
                if (!quotaServices.includes(item.ServiceType) || !quota) {
                    return null
                }
                let res = null;
                if (quota.PlacesStatus === 2) {
                    res = "not-aviailable"
                } else if (quota.PlacesStatus === 4) {
                    res = "request"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                  if (item.ServiceType==3 )
                  {
                    if (hotel.allData.HotelDetails[0].QuotaStatus.PlacesStatus===1 && hotel.allData.HotelDetails[0].QuotaStatus.FreePlaces > 0)
                    {
                      res = "less"
                    }
                    else
                    {
                      res = "aviailable"
                    }
                  }
                  else
                  {
                    res = "less"
                  }

                } else {
                    res = "aviailable"
                }
                return res
            },
            correctPrice(val, round = false) {
                if (round) {
                    val = Math.round(val);
                }
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            getCurrencyDisplayBySettings(rate){
                if (!rate) return "";

                return this.$store.getters['getCurrencyDisplayBySettings'](rate);
            },
            showPopover(text, e) {
              if (text===null)
              {
                return
              }
                let rect = e.target.getBoundingClientRect()
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height,
                    nowrap: true
                };
                this.$store.dispatch('A_SHOW_POPOVER', res);
            },
            clearPromoAndDiscountData() {
                this.promocodeData = {
                  promoDiscount: 0,
                  promoTotalDiscount: 0,
                  promoNationalDiscount: 0,
                  promoIsDiscountIsPercent: true,
                };
                this.discountCardData = {
                  promoDiscount: 0,
                  promoTotalDiscount: 0,
                  promoNationalDiscount: 0,
                  promoIsDiscountIsPercent: true,
                };
            },
            hasCoImage(item){
                let id = item.AppliedCOInfo.map(y => y.IdCostOffer)

                let coinfo = this.coInfoList.filter(x => x.coId == id);
                
                if (coinfo.length){
                    return true;
                }        
                else
                    return false;
                },
                // получаем пути картинок ЦБ
            getCOImages(card){
                const path = `${this.$store.getters['getApiOrigin']}${this.$store.getters['getPath']}`;
                
                const keys = card?.serviceTourists?.flatMap(tourist =>
                    tourist?.AppliedCOInfo?.map(info => info.IdCostOffer) || []
                ) || [];
                
                // получаем пути иконок
                if (keys.length > 0){
                    this.$store.dispatch('tour/A_GET_CO_IMAGES', {Path: path, Keys: keys})
                    .then(res => {
                        if (res){
                            this.coInfoList = res.data.map(item => ({
                                coId: item.Key,
                                imgPath: item.Value
                            }));
                        }
                    })
                }
            },
        },
        watch: {
            windowWidth(val) {
                if (val <= 1400) this.scroll();
            },
            clientAgree(val) {
                this.$emit('changeClientAgree', val)
            },
            discountTypeData() {
                const checkPromocodeValue = Object.values(this.promocodeData).some(x => x !== 0);
                const checkDiscountCardValue = Object.values(this.discountCardData).some(x => x !== 0);
                if (checkPromocodeValue || checkDiscountCardValue) {
                    this.clearPromoAndDiscountData();
                    this.$emit('applyPromoOrDiscount', {type: "clear"});
                }
            },
            tourCardData: {
                deep: true,
                handler(item) {
                  if (this.discountTypeData.value === 0) {
                    this.promocodeData.promoDiscount = item.promoDiscount;
                    this.promocodeData.promoIsDiscountIsPercent = item.promoIsDiscountIsPercent;
                    this.promocodeData.promoTotalDiscount = item.promoTotalDiscount;
                    this.promocodeData.promoNationalDiscount = item.promoNationalDiscount;
                  } else {
                    this.discountCardData.promoDiscount = item.promoDiscount;
                    this.discountCardData.promoIsDiscountIsPercent = item.promoIsDiscountIsPercent;
                    this.discountCardData.promoTotalDiscount = item.promoTotalDiscount;
                    this.discountCardData.promoNationalDiscount = item.promoNationalDiscount;
                  }

                  this.coInfoList = [];
                  this.getCOImages(this.tourCardData);
                }
            }
        },
        components: {
            promocodesBlock,
            quickBookingQuiQuo
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.scroll)
        },
    }
</script>

<style scoped> 
    .qui-quo-item {
        margin-bottom: 4px;
    }

    .basket .basket-content-wrap .basket-nav-card-wrap {
        min-width: 374px;
    }

    .basket .basket-content-wrap .basket-nav-card-wrap.disabled {
        pointer-events: none;
    }

    .basket .basket-content-wrap.small .basket-nav-card-wrap {
        position: fixed;
        top: 20px;
        left: 100%;
        transition: all .2s;
        /*min-width: 400px;*/
        z-index: 100;
        opacity: 0;
    }

    .card-header {
        background: var(--primary-color);
        padding: 12px 16px;
        border-radius: 4px 4px 0 0;
    }

    .card-header span {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        color: var(--white-color);
    }

    .basket .basket-content-wrap.small .basket-nav-card-wrap.open {
        transform: translateX(-100%);
    }

    .basket .basket-content-wrap.small .basket-nav-card-wrap .basket-icon {
        position: absolute;
        left: 2px;
        top: 0;
        transform: translateX(-90%);
        background: var(--orange-color);
        padding: 14px 10px 13px 14px;
        box-shadow: 1px 1px 14px rgba(0, 0, 0, 0.12);
        border-radius: 50% 0 0 50%;
        border: 2px solid var(--white-color);
        cursor: pointer;
        z-index: -1;
        transition: .2s all;
    }
    .basket .basket-content-wrap.small .basket-nav-card-wrap:not(.open) .basket-icon:hover {
        transform: translateX(-100%);
    }

    .basket .basket-content-wrap.small .basket-nav-card {
        overflow: auto;
        position: static;
        top: 0;
        margin-top: 0;
        max-height: calc(100vh - 52px);
        border-radius: 0 0 4px 4px;
    }

    .basket .basket-content-wrap .basket-nav-card {
        position: sticky;
        top: 20px;
        margin-bottom: 12px;
        width: 374px;
        background-color: var(--white-color);
        box-shadow: 1px 1px 14px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        z-index: 10;
    }

    .basket .basket-content-wrap .basket-nav-card .price-row {
        padding: 18px 16px;
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .basket-content-wrap .basket-nav-card .price-row .error-price {
        font-size: 14px;
        color: red;
        /*text-align: end;*/
        line-height: 0;
        margin-top: 6px;
    }

    .basket .basket-content-wrap .basket-nav-card .price-row .treveler-count,
    .basket .basket-content-wrap .basket-nav-card .price-row .price {
        font-weight: bold;
        color: #1D1D1D;
    }

    .basket .basket-content-wrap .basket-nav-card .price-row .treveler-count {
        font-size: 15px;
        line-height: 18px;
    }

    .basket .basket-content-wrap .basket-nav-card .price-row .price {
        font-size: 24px;
        line-height: 28px;
        text-align: right;
    }
    .basket .basket-content-wrap .basket-nav-card .price-row .main-info {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #1D1D1D;
    }

    .basket .basket-content-wrap .basket-nav-card .card-row {
        padding: 15px 16px;
        display: grid;
        grid-template-columns: auto 1fr;
        grid-gap: 16px;
        align-items: center;
        transition: all .2s;
        cursor: pointer;
    }

    .basket .basket-content-wrap .basket-nav-card .card-row:hover {
        background-color: var(--primary-2-color);
    }

    .basket .basket-content-wrap .basket-nav-card .card-row:not(:last-child) {
        border-bottom: 1px solid #E0E0E0;
    }

    .basket .basket-content-wrap .basket-nav-card .card-row .row-text {
        font-weight: 500;
        font-size: 13px;
        line-height: 17px;
    }

    .basket .basket-content-wrap .basket-nav-card .card-row .row-text p {
        color: #1d1d1d;
    }

    .basket .basket-content-wrap .basket-nav-card .card-row .row-text span {
        color: var(--primary-color);
        transition: all .2s;
        cursor: pointer;
    }

    .basket .basket-content-wrap .basket-nav-card .buy-btn-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
    }

    .basket .basket-content-wrap .basket-nav-card .buy-btn-item {
        flex-grow: 1;
    }

    .basket .managers-branches-wrap {
        padding: 15px 16px;
    }

    .basket .card-loader-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

    .basket .user-info,
    .basket .comission-info {
        padding: 15px 16px;
        border-bottom: 1px solid #d1d1d1;
    }

    .basket .comission-info .agencies-drop-icon {
        transform: rotate(-90deg);
        transition: all .2s;
    }

    .basket .comission-info .agencies-drop-icon.active {
        transform: rotate(-270deg);
    }

    .basket .price-status-block {
        padding: 15px 16px;
    }
    .basket .price-status-block .additional {
        border: 1px solid #d1d1d1;
        border-radius: 4px;
        position: relative;
        margin: 8px -6px 0;
        padding: 5px 5px 0;
    }
    .basket .price-status-block .additional .title {
        font-size: 14px;
        color: #727272;
        position: absolute;
        top: -10px;
        background: var(--white-color);
        padding: 0 2px;
        left: 3px;
    }

    .basket .comission-info .comission-row,
    .basket .user-info .user-info-row,
    .basket .price-status-block .row {
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: space-between;
        font-size: 14px;
        color: #727272;
        padding: 4px 0;
    }

    .basket .comission-info .comission-row:not(:last-child),
    .basket .price-status-block .row:not(:last-child) {
        border-bottom: 1px dashed #d1d1d1;
    }
    .basket .price-status-block .row:first-child {
        border: none;
    }
    .basket .price-status-block .row .total-pay {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #1D1D1D;
    }
    .basket .price-status-block .row .total-pay-price {
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #1D1D1D;
    }

    .additional-title,
    .required-title {
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        padding: 10px;
        color: var(--dark-1-color);
    }

    .icon-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
    }

    .links-wrap {
        padding: 16px;
    }

    .links-wrap p,
    .links-wrap a {
        font-size: 13px;
        line-height: 16px;
        color: var(--primary-color);
        cursor: pointer;
        display: block;
        text-decoration: underline;
        margin-bottom: 4px;
    }

    .discount-label {
        word-break: break-all
    }
</style>
